






















require('axios')
import { Component, Prop, Vue } from 'vue-property-decorator';
import NewApi, { BasePath, ImagePath, ImageThumbPath } from '../ts/api';
import { DefaultApi, Image } from '../api';

import vueDropzone  from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'


let api: DefaultApi;

@Component(
  {
    components:{
      vueDropzone ,
    }
  }
)
export default class HelloWorld extends Vue {
  
  imgs = [] as Image[];

  bearer = "Bearer " + localStorage.getItem('token')
  
dropzoneOptions = {
          url: BasePath() + "/image",
          thumbnailWidth: 150,
          maxFilesize: 15,
          paramName: "filename",
          headers: {"Authorization": this.bearer},
      }

  mounted(){
    api = NewApi()
    
    this.getImages()
  }
  
onComplete(){
  this.getImages()
}

  getImages(){
    var resp = api.imageGet()
    resp.then(i => this.imgs = i.data).catch(e => console.error("fail to fetch images")) 
  }

  getImagePath(s :string){
return ImageThumbPath(s)
  }


  postImage(files :File[]){
    api.imagePost(files).then(r => this.getImages()).catch(e => console.error("could not upload images"))
}

  highlightImage(img :Image){
    img.highlight = !img.highlight
    console.log("highlite")
    //TODO Put image
    api.imagePut(img).catch(e => console.error("could not put image"))
  }

  deleteImage(image :Image){
    let ctx = this
    api.imageDelete(image.id).then(function(r){
  ctx.imgs = ctx.imgs.filter(item => item.id != image.id);
       console.log("image deleted")
       }).catch(e => "could not delete image")
  }
}
